/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const search = (
	<SVG xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
		<Path
			d="M23.0971 21.982L6.60742 38.5347L9.42724 41.3653L25.9169 24.8126L23.0971 21.982Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M9.12753 46.6427C11.2034 44.2897 22.2386 31.6156 22.2386 31.6156L16.3189 25.6733C16.3189 25.6733 3.693 36.7529 1.34904 38.8367C-0.780014 40.7293 -0.217287 42.8108 1.82758 44.8635L3.12363 46.1645C5.1685 48.2172 7.24217 48.7821 9.12753 46.6449V46.6427Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M33.5384 29.0332C25.565 29.0332 19.0781 22.5216 19.0781 14.5177C19.0781 6.51385 25.565 0 33.5384 0C41.5119 0 47.9988 6.51163 47.9988 14.5155C47.9988 22.5194 41.5119 29.031 33.5384 29.031V29.0332ZM33.5384 4.00305C27.7627 4.00305 23.066 8.71998 23.066 14.5155C23.066 20.311 27.7649 25.028 33.5384 25.028C39.3119 25.028 44.0109 20.311 44.0109 14.5155C44.0109 8.71998 39.3119 4.00305 33.5384 4.00305Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
	</SVG>
);
